module.exports = __webpack_public_path__ + "static/krystian-biela-x2-fde61dbd6768729237bfdf883a03bf18.jpg";